module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAAQCAYAAABui5P/AAAA80lEQVRYhe1YWw7CMAxbEffgpJyMwwH7qFRlSeM8prbT/DWWxs5M0wXK94/tRgiP0QVcAUuaWEoZmk+xnIm7AZETKJrP4YkKt+CKqGt6MSkf4Ufr8xhkqY/jV03kvjl6r/3ciyHrpXtofdadZq2PWx9uZ0q6X2efOZIWh55+Ritz/KqJGaJn8keRoW/eiWcf7FIc1Y3uQqQ+CujFYi3Em+/hp+0VOU44fYQfNnFGAysyWrKnr/FD7TzawNH6GlQTpRGggm5vdMRB4wg0Pi1X09f4XcM2RWskMmxb4taxxjNzhp9v9n9xZvyZd9B4fd5Tm7gCfjTF8YWVhBNBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nrtb1-6.png
// module id = 679
// module chunks = 0